// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__jJvHB","assignButton":"CreateEditEquipmentSchedule_assignButton__1AYOn"};